<template>
  <div style="padding: 0 20px;">
    <el-row>
      <el-col :span="24">
        <el-button
            style="padding: 0; margin: 20px"
            type="text"
            icon="el-icon-back"
            @click="toList()"
        >
          返回
        </el-button>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-form ref="form" :model="form" label-width="150px" :disabled="formLoading">
        <el-form-item label="活动类型" required>
          <el-select v-model="form.type" @change="changeActivityType" placeholder="请选择" :disabled="type=='update'">
            <el-option
                v-for="item in typeOptions"
                :key="item.key"
                :label="item.value"
                :value="item.key">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标题" required>
          <el-input size="medium" v-model="form.title" style="width:400px"></el-input>
        </el-form-item>
        <el-form-item label="奖金金额" required>
          <el-input type="number" size="medium" v-model="form.bonus_amount" style="width:100px"></el-input>
        </el-form-item>
        <el-form-item label="剩余奖金金额" required>
          <el-input type="number" size="medium" v-model="form.remaining_bonus" style="width:100px"></el-input>
          <span style="color:#909399">剩余难度</span>
        </el-form-item>
        <el-form-item label="初始奖金金额" required>
          <el-input type="number" size="medium" v-model="form.initial_bonus_start" style="width:100px"></el-input>
          ~
          <el-input type="number" size="medium" v-model="form.initial_bonus_end" style="width:100px"></el-input>
        </el-form-item>
        <el-form-item label="活动时间" required>
          <el-date-picker v-model="form.start_at" value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
                          placeholder="选择开始时间" :disabled="type=='update' && form.status == 1"></el-date-picker>
          ~
          <el-date-picker v-model="form.end_at" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择结束时间"
                          :disabled="type=='update' && form.status == 1"></el-date-picker>
        </el-form-item>
        <el-divider></el-divider>

        <template v-if="form.type == 1">
          <el-form-item label="奖品ID" required>
            <el-input type="number" size="medium" v-model="form.give_ids" style="width:100px"></el-input>
          </el-form-item>
        </template>
        <template v-else>
          <el-form-item label="奖品ID" required>
            <el-select v-model="form.give_ids" placeholder="请选择">
              <el-option
                  v-for="item in vipList"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key">
              </el-option>
            </el-select>
          </el-form-item>
        </template>

        <el-form-item label="奖品图片" required>
          <el-upload
              class="avatar-uploader"
              :action="ossAction"
              :show-file-list="false"
              :http-request="uploadOSSRequest">
            <img v-if="form.give_img_url" :src="form.give_img_url" class="avatar"
                 :preview-src-list="[form.give_img_url]">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="奖品标题" required>
          <el-input size="medium" v-model="form.give_title" style="width:400px"></el-input>
        </el-form-item>
        <el-form-item label="奖品描述" required>
          <el-input size="medium" autosize v-model="form.give_intro" style="width:600px"></el-input>
        </el-form-item>
        <el-form-item label="奖品划线价" required>
          <el-input type="number" size="medium" v-model="form.give_scribing_price" style="width:100px"></el-input>
        </el-form-item>
        <el-form-item label="奖品价" required>
          <el-input type="number" size="medium" v-model="form.give_price" style="width:100px"></el-input>
        </el-form-item>
        <el-divider></el-divider>

        <el-form-item label="福袋ID" required>
          <el-row>
            <template v-for="num in 3">
              <el-col :span="6" :key="num">
                <el-input type="number" size="medium" v-model="form.lucky_bag_ids[num - 1]" style="width:100px"></el-input>
                <template v-if="typeof form.lucky_bag_ids_list[form.lucky_bag_ids[num - 1]] != 'undefined'">
                  <div style="color:#909399">
                    <span>{{ form.lucky_bag_ids_list[form.lucky_bag_ids[num - 1]]['title'] }} <br>
                    开课时间：{{ form.lucky_bag_ids_list[form.lucky_bag_ids[num - 1]]['begin_at'] }} ~ {{ form.lucky_bag_ids_list[form.lucky_bag_ids[num - 1]]['end_at'] }}</span>
                  </div>
                </template>
              </el-col>
            </template>
            <el-col :span="6">
              <span style="color:#909399">课程ID</span>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="福袋价格" required>
          <el-input type="number" size="medium" v-model="form.lucky_bag_price[0]" style="width:100px"></el-input>
          ，
          <el-input type="number" size="medium" v-model="form.lucky_bag_price[1]" style="width:100px"></el-input>
          ，
          <el-input type="number" size="medium" v-model="form.lucky_bag_price[2]" style="width:100px"></el-input>
          <span style="color:#909399">福袋价格</span>
        </el-form-item>
        <el-form-item label="福袋优惠券ID" required>

          <el-row>
            <template v-for="num in 3">
              <el-col :span="6" :key="num">
                <el-input type="number" size="medium" v-model="form.lucky_bag_extra_ids[num - 1]" style="width:100px"></el-input>
                <template v-if="typeof form.lucky_bag_extra_ids_list[form.lucky_bag_extra_ids[num - 1]] != 'undefined'">
                  <div style="color:#909399">
                    <span>
                      {{ form.lucky_bag_extra_ids_list[form.lucky_bag_extra_ids[num - 1]]['name'] }}，
                      满{{form.lucky_bag_extra_ids_list[form.lucky_bag_extra_ids[num - 1]]['start']}}
                      减{{form.lucky_bag_extra_ids_list[form.lucky_bag_extra_ids[num - 1]]['reduce']}} <br>
                      {{form.lucky_bag_extra_ids_list[form.lucky_bag_extra_ids[num - 1]]['begin_at']}} ~
                      {{form.lucky_bag_extra_ids_list[form.lucky_bag_extra_ids[num - 1]]['expire_at']}}
                    </span>
                  </div>
                </template>
              </el-col>
            </template>
            <el-col :span="6">
              <span style="color:#909399">优惠券ID</span>
            </el-col>
          </el-row>
        </el-form-item>
        <el-divider></el-divider>

        <el-form-item label="分享图标" required>
          <el-upload
              class="avatar-uploader"
              :action="ossAction"
              :show-file-list="false"
              :http-request="uploadOSSRequest2">
            <img v-if="form.share_icon" :src="form.share_icon" class="avatar" :preview-src-list="[form.share_icon]">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="分享标题" required>
          <el-input size="medium" v-model="form.share_title" style="width:400px"></el-input>
        </el-form-item>
        <el-form-item label="分享描述" required>
          <el-input size="medium" autosize v-model="form.share_desc" style="width:600px"></el-input>
        </el-form-item>

        <el-form-item label="分享海报" >
          <activityCustomUpload :formName="'share_poster'" :formValue="form.share_poster" @uploadSuccess="uploadSuccess"></activityCustomUpload>
        </el-form-item>
      <el-form-item label="分享海报" prop="share_poster_multiple">
                <el-col :span="8">
                    <activityCustomUpload 
                    :formName="'share_poster_1'" :formValue="form.share_poster_1"
                    @uploadSuccess="uploadSuccess">
                    </activityCustomUpload>
                </el-col>
                <el-col :span="8">
                    <activityCustomUpload 
                    :formName="'share_poster_2'" :formValue="form.share_poster_2"
                    @uploadSuccess="uploadSuccess">
                    </activityCustomUpload>
                </el-col>
                <el-col :span="8">
                    <activityCustomUpload 
                    :formName="'share_poster_3'" :formValue="form.share_poster_3"
                    @uploadSuccess="uploadSuccess">
                    </activityCustomUpload>
                </el-col>
        </el-form-item>
        <el-divider></el-divider>
        <el-form-item label="引流图标" >
          <activityCustomUpload :formName="'drainage_img'" :formValue="form.drainage_img" @uploadSuccess="uploadSuccess"></activityCustomUpload>
        </el-form-item>
        <el-form-item label="引流链接" >
          <el-input size="medium" v-model="form.drainage_link" style="width:400px"></el-input>
        </el-form-item>
        <el-form-item label="助力页横图" >
          <activityCustomUpload :formName="'assist_page_ad_img'" :formValue="form.assist_page_ad_img" @uploadSuccess="uploadSuccess"></activityCustomUpload>
        </el-form-item>
        <el-form-item label="引流链接" >
          <el-input size="medium" v-model="form.assist_page_ad_link" style="width:400px"></el-input>
        </el-form-item>
        <el-form-item>
          <template v-if="type == 'create'">
            <el-button type="primary" @click="onSubmit" :loading="onSubmitLoading">立即创建</el-button>
          </template>
          <template v-else>
            <el-button type="primary" @click="onUpdate" :loading="onSubmitLoading">保存</el-button>
          </template>

          <el-button @click="toList()">取消</el-button>
        </el-form-item>
      </el-form>
    </el-row>
  </div>
</template>

<script>
import activityCustomUpload from "@/components/activityCustomUpload.vue";
import {
  createAssist, getAssistInfo, updateAssist
} from "@/api/activityAssist";
import {uploadOSSRequest, getAliyunOssToken} from "@/api/common";

export default {
  components: { activityCustomUpload },
  data: function () {
    return {
      formLoading: false,
      onSubmitLoading: false,
      assistId: '',
      ossAction: "",
      updateLoading: false,
      type: 'create',
      data: {},
      typeOptions: [
        {key: 1, value: "领课程"},
        {key: 2, value: "领会员"},
      ],
      vipList: [
        {key: 2, value: "七天会员"},
        {key: 3, value: "半月会员"},
        {key: 4, value: "月会员"},
        {key: 6, value: "季会员"},
        {key: 10, value: "年会员"},
      ],
      form: {
        lucky_bag_ids: [],
        lucky_bag_ids_list: [],
        lucky_bag_price: [],
        lucky_bag_extra_ids: [],
        lucky_bag_extra_ids_list: [],
        give_img_url: '',
        share_icon: '',
        type: 1,
        give_ids: '',
        share_poster_1:'',
        share_poster_2:'',
        share_poster_3:'',
        assist_page_ad_link:'',
        assist_page_ad_img:'',
      },
    };
  },
  created: function () {
    this.type = this.$route.query.type
    if (this.type == 'update') {
      this.assistId = this.$route.query.id;
      this.getAssistInfo()
    }
  },
  methods: {
    uploadSuccess(value){
      this.$set(this.form, value.formName, value.fileUrl)
    },
    uploadSuccess2(value) {
            console.log( value, '[[[[[]]]]]');
            // const foundObject = this.info.certs.find(
            //     (obj) => obj.id === value.id
            // );
            // // console.log(foundObject);
            const fileExtension = value.fileUrl.split(".").pop().toLowerCase();

            // 判断是否是图片格式
            const isImageFormat = ["png", "jpeg", "jpg", "gif", ""].includes(
                fileExtension
            );

            if (isImageFormat) {
                console.log("是图片格式");
                if(value.formName == 'multiple1'){
                this.form.share_poster_multiple[0] = value.fileUrl
                console.log(this.form.share_poster_multiple);
                
                }
            } else {
                this.$message({
                    message: "请上传图片格式文件",
                    type: "error",
                });
                return;
            }
      },
    changeActivityType(value) {
      console.log(this.form.give_ids)
      if (value == 1) {
        this.form.give_ids = ''
      } else {
        this.form.give_ids = 2
      }
    },
    getAssistInfo() {
      this.formLoading = true;
      getAssistInfo({
        id: this.assistId
      }).then((res) => {
        if (res.code == 1) {
          this.formLoading = false;
          this.form = res.data
        }
      });
    },
    onUpdate() {
      this.onSubmitLoading = true;
      updateAssist(this.form).then((res) => {
        this.onSubmitLoading = false;
        if (res.code == 1) {
          this.getAssistInfo()
          this.$message({
            showClose: true,
            duration: 6000,
            message: '修改成功',
            type: 'success'
          });
          // this.toList();
        }
      });
    },
    onSubmit() {
      this.onSubmitLoading = true;
      createAssist(this.form).then((res) => {
        this.onSubmitLoading = false;
        if (res.code == 1) {
          this.form = {
            lucky_bag_ids: [],
            lucky_bag_extra_ids: [],
            give_img_url: '',
            share_icon: '',
          }
          this.$message({
            showClose: true,
            duration: 6000,
            message: '创建成功',
            type: 'success'
          });
          this.toList();
        }
      });
    },
    uploadOSSRequest(file) {
      let that = this
      this.updateLoading = true;
      getAliyunOssToken({dir: "activity/assist/"}).then((res) => {
        uploadOSSRequest(file.file, res.data).then((fileUrl) => {
          console.log(fileUrl)
          that.form.give_img_url = fileUrl
          console.log(that.form)
        });
      });
    },
    uploadOSSRequest2(file) {
      let that = this
      this.updateLoading = true;
      getAliyunOssToken({dir: "activity/assist/"}).then((res) => {
        uploadOSSRequest(file.file, res.data).then((fileUrl) => {
          that.form.share_icon = fileUrl
        });
      });
    },
    toList() {
      this.$router.push({
        path: "/activity/assist/data",
      });
    }
  }
};
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  min-height: 70px;
  line-height: 70px;
  text-align: center;
}

.avatar {
  width: 100px;
  min-height: 70px;
  display: block;
}
</style>

